import { render } from "./removeTaskModal.vue?vue&type=template&id=52b3fdd6&scoped=true&ts=true"
import script from "./removeTaskModal.vue?vue&type=script&lang=ts"
export * from "./removeTaskModal.vue?vue&type=script&lang=ts"

import "./removeTaskModal.vue?vue&type=style&index=0&id=52b3fdd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b3fdd6"]])

export default __exports__